export const VRBO = 'Vrbo';

export const ADD_PHOTO_TEXT = 'Add a photo';
export const BED_AND_BREAKFAST = 'BedandBreakfast.com';
export const CERTIFICATE_NUMBER_LABEL = 'Certificate number';
export const CONTACT_INFORMATION_TEXT = 'Contact information';
export const COUNTRY_CODE_LABEL = 'Country code';
export const DROP_FILE_TEXT = 'or drop a file here';
export const EMAIL_LABEL = 'E-mail address';
export const RESERVATION_INFORMATION_LABEL = 'Expedia reservation information';
export const RESERVATION_INFORMATION_LABEL_TEXT = 'Expedia reservation confirmation number';
export const ERROR_CERTIFICATE_NUMBER = 'Please enter a valid certificate number';
export const ERROR_EMAIL = 'Please enter a valid email address';
export const ERROR_RESERVATION_NUMBER = 'Please enter a valid Expedia reservation number';
export const ERROR_FILE_TYPE_NOT_SUPPORTED = 'Sorry, this file type is not supported.';
export const ERROR_MAX_IMAGE_SIZE = 'Sorry, the image size is too large. Please ensure the size is less than 5MB';
export const ERROR_NAME = 'Please enter a valid name';
export const ERROR_ORDERID = 'Please enter a valid order id';
export const ERROR_PHONE = 'Please enter a valid phone number';
export const ERROR_UPLOAD_IMAGE = 'Please upload a gift card image';
export const EXPLORE_BNB_RENTALS_TEXT = 'Explore bed and breakfast rentals';
export const EXPLORE_BNB_RENTALS_TEXT_ARIA = 'Form submitted successfully! Explore bed and breakfast rentals.';
export const EXPLORE_BNB_RENTALS_LINK = 'https://www.vrbo.com/travel/bed-and-breakfasts';
export const FIRST_NAME_LABEL = 'First name';
export const FORM_SUBMIT_SUCCESS_TEXT = 'Form submitted successfully!';
export const GIFT_CARD_ADD_TEXT = 'Add another gift card';
export const GIFT_CARD_COUNT_LIMIT = 5;
export const GIFT_CARD_INFORMATION_TEXT = 'Gift card information';
export const GIFT_CARD_REDEMPTION_FORM = 'Gift card redemption form';
export const GIFT_CARD_SUBMIT_TEXT = 'Submit request';
export const GIFT_CARD_SUBMIT_TEXT_ARIA = `Redeem your ${BED_AND_BREAKFAST} gift card. Submit request`;
export const GIFT_CARD_SUBMIT_TEXT_ERROR_ARIA = 'Unable to process the request, please try again. Submit request';
export const GIFT_CARD_SUBTITILE = `${BED_AND_BREAKFAST} is now part of ${VRBO}`;
export const GIFT_CARD_TITLE = `Redeem your ${BED_AND_BREAKFAST} gift card`;
export const GIFT_CARDS_TEXT = 'Gift cards';
export const LAST_NAME_LABEL = 'Last Name';
export const LEARN_MORE_LINK = 'https://help.vrbo.com/articles/How-do-I-redeem-my-BedandBreakfast-com-gift-card';
export const LEARN_MORE_TEXT = 'Learn more';
export const MAX_IMAGE_SIZE = 5000000;
export const MAX_PAYLOAD_SIZE = 30000000;
export const MESSAGE = `Have a ${BED_AND_BREAKFAST} gift card? Fill out the form below and a member of our support team will contact you for additional details.`;

export const NOTE = 'Gift cards can not be applied to a rental purchase and can only be redeemed through this form.';
export const ORDER_ID_LABEL = 'Order id';
export const PHONE_NUM_LABEL = 'Phone number';
export const PLEASE_NOTE_TEXT = 'Please note: ';
export const REMOVE_IMAGE_TEXT = 'Remove the uploaded image';
export const SECURITY_MESSAGE = 'For security purposes, we require a photo of your gift card or a screenshot of your gift card email. Please make sure the card details are visible.';
export const GIFT_CARD_IMAGE_URL = 'https://csvcus.homeaway.com/rsrcs/stab-cms-resources/0.17.2/images/traveler-bnb/gift-card-illustration@2x.png';
export const ERROR_MESSAGE_ID_TEXT = 'error-message';
export const GENERIC_ERROR_MESSAGE = 'Unable to process the request, please try again.';
